import Growl from '@ux/growl';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import hasWindow from './hasWindow';

const { addGrowlMessage: realAddGrowlMessage } = Growl;

let addGrowlProxyFn;

export const ConditionalGrowl = () => {

  const [growlExists, setGrowlExists] = useState(true);
  const [growlStack, setGrowlStack] = useState([]);
  const growlContainer = useRef();

  addGrowlProxyFn = useCallback((...args) => {
    if (window.growlInstance) {
      return realAddGrowlMessage(...args);
    }
    setGrowlStack(previousGrowlStack => [
      ...previousGrowlStack, () => {
        realAddGrowlMessage(...args);
      }
    ]);
    return setGrowlExists(false);
  }, []);

  useEffect(() => {
    if (growlContainer.current && growlStack.length > 0) {
      growlStack.forEach(growlFn => growlFn());
      setGrowlStack([]);
    }
  }, [growlContainer, growlStack]);

  if (!hasWindow()) {
    return null;
  }

  if (!growlExists) {
    return <div ref={ growlContainer }><Growl /></div>;
  }
  return null;
};

export const addGrowlMessage = (...args) => addGrowlProxyFn(...args);
export default ConditionalGrowl;
